export interface Movie {
  id: number;
  title: string;
  type: "电影" | "电视剧";
  genres: string[];
  region: string;
  year: number;
  rating: number;
  hot: number;
  updated: string;
  image: string;
  director: string;
  actors: string[];
  episodes: number;
  synopsis: string;
}

export const movies: Movie[] = [
  {
    id: 1,
    title: "星际迷航者",
    type: "电影",
    genres: ["科幻", "冒险"],
    region: "美国",
    year: 2024,
    rating: 9.1,
    hot: 9850,
    updated: "2024-09-18",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20space%20epic%20movie%20poster%20art%2C%20lone%20astronaut%20standing%20before%20a%20giant%20glowing%20planet%2C%20deep%20blue%20nebula%20and%20warm%20orange%20star%20light%2C%20dramatic%20cinematic%20lighting%2C%20high%20detail%2C%20moody%20atmospheric%20premium%20streaming%20key%20art%2C%20no%20text&width=480&height=672&seq=poster-01&orientation=portrait",
    director: "克里斯·诺兰",
    actors: ["莱昂·哈特", "艾米莉亚·柯尔", "汤姆·雷德"],
    episodes: 148,
    synopsis: "一支深空探索队在宇宙边缘发现了一颗被遗忘的宜居星球。当通讯中断、补给耗尽，队长必须在拯救同伴与揭开星球秘密之间做出抉择。影片以恢弘的视觉与细腻的情感，讲述人类在无垠星海中的孤独与勇气。",
  },
  {
    id: 2,
    title: "长安夜行",
    type: "电视剧",
    genres: ["古装", "悬疑"],
    region: "中国大陆",
    year: 2023,
    rating: 8.7,
    hot: 9120,
    updated: "2024-08-02",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20period%20mystery%20drama%20poster%20art%2C%20ancient%20lantern%20lit%20city%20street%20at%20night%2C%20deep%20blue%20moonlight%20and%20warm%20orange%20lantern%20glow%2C%20dramatic%20cinematic%20lighting%2C%20high%20detail%2C%20atmospheric%20historical%20key%20art%2C%20no%20text&width=480&height=672&seq=poster-02&orientation=portrait",
    director: "张牧之",
    actors: ["陈砚", "苏禾", "李承远"],
    episodes: 36,
    synopsis: "盛唐长安，一桩离奇命案牵出深埋多年的宫廷秘辛。年轻提刑官携手女仵作，在灯影摇曳的夜色中逐层拨开迷雾。剧集以考究的唐风美学与环环相扣的悬念，勾勒出一幅长安众生图。",
  },
  {
    id: 3,
    title: "暗夜追凶",
    type: "电影",
    genres: ["犯罪", "悬疑"],
    region: "香港",
    year: 2022,
    rating: 8.3,
    hot: 8760,
    updated: "2024-07-15",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20Hong%20Kong%20crime%20thriller%20movie%20poster%20art%2C%20rain%20soaked%20neon%20city%20alley%20with%20a%20lone%20detective%20silhouette%2C%20deep%20blue%20night%20tones%20and%20warm%20orange%20neon%2C%20dramatic%20lighting%2C%20high%20detail%2C%20noir%20key%20art%2C%20no%20text&width=480&height=672&seq=poster-03&orientation=portrait",
    director: "黄志强",
    actors: ["周镇宇", "林嘉欣", "吴俊豪"],
    episodes: 132,
    synopsis: "一名执拗的老刑警在退休前接手的最后一案，竟与二十年前的悬案惊人相似。随着线索逐渐汇聚，他发现真凶或许一直近在咫尺。影片用冷峻的镜头语言，探讨正义与执念的边界。",
  },
  {
    id: 4,
    title: "心动信号",
    type: "电视剧",
    genres: ["爱情", "都市"],
    region: "韩国",
    year: 2024,
    rating: 8.0,
    hot: 8320,
    updated: "2024-09-05",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20romantic%20drama%20poster%20art%2C%20two%20lovers%20under%20city%20lights%20at%20dusk%2C%20soft%20deep%20blue%20evening%20sky%20and%20warm%20orange%20bokeh%2C%20dreamy%20cinematic%20lighting%2C%20high%20detail%2C%20emotional%20key%20art%2C%20no%20text&width=480&height=672&seq=poster-04&orientation=portrait",
    director: "金志勋",
    actors: ["朴敏书", "李在允", "崔秀彬"],
    episodes: 16,
    synopsis: "一位理性的数据分析师与一位浪漫的漫画家意外成为合租室友。两个世界截然不同的人，在一次次鸡飞狗跳的日常中慢慢靠近。剧集用轻盈细腻的笔触，描绘都市里最真实的心动。",
  },
  {
    id: 5,
    title: "深海迷航",
    type: "电影",
    genres: ["科幻", "冒险"],
    region: "美国",
    year: 2023,
    rating: 8.8,
    hot: 7980,
    updated: "2024-06-20",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20deep%20sea%20adventure%20movie%20poster%20art%2C%20submarine%20descending%20into%20glowing%20abyss%2C%20deep%20blue%20water%20and%20warm%20orange%20bioluminescence%2C%20dramatic%20cinematic%20lighting%2C%20high%20detail%2C%20mysterious%20ocean%20key%20art%2C%20no%20text&width=480&height=672&seq=poster-05&orientation=portrait",
    director: "詹姆斯·卡特",
    actors: ["艾娃·摩尔", "丹尼尔·克鲁", "丽娜·帕克"],
    episodes: 126,
    synopsis: "深海科考船在马里亚纳海沟底部捕捉到未知声波信号。当潜航器深入万米黑暗，队员们发现了一座不该存在的海底遗迹。影片以令人窒息的压迫感，讲述人类对未知深渊的敬畏与探索。",
  },
  {
    id: 6,
    title: "江湖旧梦",
    type: "电视剧",
    genres: ["武侠", "剧情"],
    region: "中国大陆",
    year: 2022,
    rating: 8.5,
    hot: 7650,
    updated: "2024-05-30",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20wuxia%20movie%20poster%20art%2C%20swordsman%20on%20a%20misty%20mountain%20peak%2C%20deep%20blue%20mist%20and%20warm%20orange%20sunset%20glow%2C%20dramatic%20cinematic%20lighting%2C%20high%20detail%2C%20elegant%20martial%20arts%20key%20art%2C%20no%20text&width=480&height=672&seq=poster-06&orientation=portrait",
    director: "顾长风",
    actors: ["萧云生", "白若雪", "陆行舟"],
    episodes: 40,
    synopsis: "江湖传言失传已久的绝世剑谱重现人间，各大门派为此展开明争暗斗。一位隐居山林的落魄剑客被迫重出江湖，却发现恩怨背后另有隐情。剧集以写意的武打设计与悠远的意境，重塑快意恩仇的江湖。",
  },
  {
    id: 7,
    title: "笑傲江湖客",
    type: "电影",
    genres: ["喜剧"],
    region: "中国大陆",
    year: 2024,
    rating: 7.6,
    hot: 7210,
    updated: "2024-09-12",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20comedy%20movie%20poster%20art%2C%20cheerful%20colorful%20city%20square%20with%20playful%20characters%2C%20bright%20deep%20blue%20sky%20and%20warm%20orange%20accents%2C%20fun%20cinematic%20lighting%2C%20high%20detail%2C%20lively%20key%20art%2C%20no%20text&width=480&height=672&seq=poster-07&orientation=portrait",
    director: "马晓东",
    actors: ["沈腾飞", "贾小玲", "黄博文"],
    episodes: 118,
    synopsis: "一个总想一夜成名的龙套演员，误打误撞卷进了一场荒诞的江湖纷争。为了保命，他不得不把自己包装成隐世高手。影片笑料密集又暗藏温情，讲述小人物在荒诞世界里的生存智慧。",
  },
  {
    id: 8,
    title: "无声证词",
    type: "电视剧",
    genres: ["悬疑", "罪案"],
    region: "英国",
    year: 2023,
    rating: 8.9,
    hot: 6980,
    updated: "2024-08-22",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20British%20detective%20poster%20art%2C%20foggy%20london%20street%20with%20a%20lone%20figure%2C%20deep%20blue%20fog%20and%20warm%20orange%20street%20lamp%20glow%2C%20dramatic%20cinematic%20lighting%2C%20high%20detail%2C%20mystery%20key%20art%2C%20no%20text&width=480&height=672&seq=poster-08&orientation=portrait",
    director: "奥利弗·贝内特",
    actors: ["亨利·肖", "克洛伊·亚当斯", "威廉·格雷"],
    episodes: 8,
    synopsis: "一位因案件失聪的法医，凭借超常的观察力重回凶案现场。在无人倾诉的寂静世界里，她用细节拼凑出被忽视的真相。剧集节奏沉稳，推理严密，被誉为近年最出色的英式悬疑之一。",
  },
  {
    id: 9,
    title: "樱花之约",
    type: "电影",
    genres: ["爱情", "剧情"],
    region: "日本",
    year: 2022,
    rating: 8.2,
    hot: 6640,
    updated: "2024-04-18",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20Japanese%20romance%20movie%20poster%20art%2C%20cherry%20blossom%20path%20in%20spring%2C%20soft%20deep%20blue%20sky%20and%20warm%20orange%20blossom%20glow%2C%20dreamy%20cinematic%20lighting%2C%20high%20detail%2C%20tender%20key%20art%2C%20no%20text&width=480&height=672&seq=poster-09&orientation=portrait",
    director: "小林和也",
    actors: ["佐藤健太", "新垣结衣", "松本润子"],
    episodes: 124,
    synopsis: "每年樱花盛开时，两人都会在老地方相见，却始终错过彼此的心意。直到一封迟到十年的信被打开，一段未能说出口的爱恋才缓缓展开。影片清新唯美，将遗憾与温柔拍得恰到好处。",
  },
  {
    id: 10,
    title: "极速狂飙",
    type: "电影",
    genres: ["动作", "赛车"],
    region: "美国",
    year: 2024,
    rating: 8.4,
    hot: 9010,
    updated: "2024-09-25",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20action%20racing%20movie%20poster%20art%2C%20sports%20car%20speeding%20through%20night%20city%2C%20deep%20blue%20motion%20blur%20and%20warm%20orange%20headlights%2C%20dramatic%20cinematic%20lighting%2C%20high%20detail%2C%20adrenaline%20key%20art%2C%20no%20text&width=480&height=672&seq=poster-10&orientation=portrait",
    director: "托尼·罗西",
    actors: ["马库斯·李", "索菲亚·雷耶斯", "凯文·布朗"],
    episodes: 136,
    synopsis: "退役车手为替兄弟还债，重返地下赛车圈，挑战从未有人征服过的死亡赛道。速度与信任的考验之下，他必须直面内心最深处的恐惧。影片实车特技与沉浸式运镜，带来肾上腺素飙升的观影体验。",
  },
  {
    id: 11,
    title: "幻境之城",
    type: "电视剧",
    genres: ["奇幻", "冒险"],
    region: "美国",
    year: 2023,
    rating: 8.6,
    hot: 7440,
    updated: "2024-08-10",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20fantasy%20series%20poster%20art%2C%20floating%20magical%20city%20above%20clouds%2C%20deep%20blue%20sky%20and%20warm%20orange%20magic%20glow%2C%20epic%20cinematic%20lighting%2C%20high%20detail%2C%20imaginative%20key%20art%2C%20no%20text&width=480&height=672&seq=poster-11&orientation=portrait",
    director: "艾米丽·张",
    actors: ["诺亚·威廉姆斯", "伊莎贝拉·陈", "卢卡斯·玛雅"],
    episodes: 10,
    synopsis: "一张神秘地图将普通少女引向漂浮在云端的幻境之城。在这里，想象力可以化为真实的力量。剧集构建了瑰丽宏大的世界观，讲述成长、友谊与守护心中之光的旅程。",
  },
  {
    id: 12,
    title: "风起云涌",
    type: "电视剧",
    genres: ["年代", "剧情"],
    region: "中国大陆",
    year: 2021,
    rating: 8.1,
    hot: 6120,
    updated: "2024-03-22",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20period%20drama%20poster%20art%2C%20nostalgic%20old%20town%20street%20in%20a%20golden%20era%2C%20deep%20blue%20dusk%20and%20warm%20orange%20window%20light%2C%20cinematic%20lighting%2C%20high%20detail%2C%20retro%20key%20art%2C%20no%20text&width=480&height=672&seq=poster-12&orientation=portrait",
    director: "赵建国",
    actors: ["王振华", "孙丽云", "周明远"],
    episodes: 48,
    synopsis: "上世纪三十年代，一个普通家族在时代洪流中几经沉浮。三代人的命运与家国变迁交织在一起，谱写出一曲荡气回肠的岁月之歌。剧集以扎实的剧作与细腻的年代质感，还原一段真实可感的历史。",
  },
  {
    id: 13,
    title: "末日黎明",
    type: "电影",
    genres: ["科幻", "灾难"],
    region: "美国",
    year: 2022,
    rating: 7.9,
    hot: 6880,
    updated: "2024-05-06",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20disaster%20movie%20poster%20art%2C%20city%20skyline%20under%20a%20dramatic%20storm%2C%20deep%20blue%20storm%20clouds%20and%20warm%20orange%20fire%20glow%2C%20dramatic%20cinematic%20lighting%2C%20high%20detail%2C%20apocalyptic%20key%20art%2C%20no%20text&width=480&height=672&seq=poster-13&orientation=portrait",
    director: "罗伯特·海因",
    actors: ["杰克·汤普森", "玛丽亚·冈萨雷斯", "伊桑·沃克"],
    episodes: 130,
    synopsis: "一场突如其来的太阳风暴让全球电网瘫痪，文明在一夜之间倒退百年。一小队幸存者踏上寻找避难所的旅程。影片在浩劫奇观之下，拷问人性中最本真的选择与希望。",
  },
  {
    id: 14,
    title: "迷雾山庄",
    type: "电影",
    genres: ["恐怖", "悬疑"],
    region: "英国",
    year: 2023,
    rating: 7.4,
    hot: 5760,
    updated: "2024-07-01",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20horror%20movie%20poster%20art%2C%20eerie%20misty%20mansion%20on%20a%20hill%2C%20deep%20blue%20darkness%20and%20warm%20orange%20candle%20glow%2C%20tense%20cinematic%20lighting%2C%20high%20detail%2C%20chilling%20key%20art%2C%20no%20text&width=480&height=672&seq=poster-14&orientation=portrait",
    director: "克莱尔·弗莱彻",
    actors: ["艾米丽·哈特", "亚当·诺斯", "露西·格雷"],
    episodes: 102,
    synopsis: "七位陌生人在一座与世隔绝的山庄中醒来，每个人都被困于一间无法打开的密室。随着一个又一个谜题被解开，他们才发现真正的恐怖来自彼此。影片以密室推理结合心理惊悚，步步紧逼。",
  },
  {
    id: 15,
    title: "时代之光",
    type: "电视剧",
    genres: ["剧情", "历史"],
    region: "中国大陆",
    year: 2024,
    rating: 9.0,
    hot: 8240,
    updated: "2024-09-28",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20historical%20drama%20poster%20art%2C%20majestic%20ancient%20capital%20skyline%2C%20deep%20blue%20twilight%20and%20warm%20orange%20city%20lights%2C%20epic%20cinematic%20lighting%2C%20high%20detail%2C%20grand%20key%20art%2C%20no%20text&width=480&height=672&seq=poster-15&orientation=portrait",
    director: "刘世坤",
    actors: ["张国立成", "陈道明宇", "李雪健峰"],
    episodes: 42,
    synopsis: "一群风华正茂的青年，在时代变革的浪潮中投身理想与建设。他们在困境中彼此扶持，用一生书写属于那个年代的荣光。剧集以群像叙事，致敬平凡人身上不平凡的时代之光。",
  },
  {
    id: 16,
    title: "童年奇遇记",
    type: "电影",
    genres: ["动画", "家庭"],
    region: "美国",
    year: 2023,
    rating: 8.7,
    hot: 7290,
    updated: "2024-06-08",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20animated%20family%20movie%20poster%20art%2C%20colorful%20whimsical%20adventure%20world%2C%20bright%20deep%20blue%20sky%20and%20warm%20orange%20accents%2C%20joyful%20cinematic%20lighting%2C%20high%20detail%2C%20charming%20key%20art%2C%20no%20text&width=480&height=672&seq=poster-16&orientation=portrait",
    director: "安娜·刘易斯",
    actors: ["配音·汤米·李", "配音·凯特·周", "配音·山姆·吴"],
    episodes: 96,
    synopsis: "一个内向的小女孩在一场奇妙的梦里，与自己童年缺失的勇气相遇。为了找回归家的路，她和一群古怪又可爱的伙伴踏上冒险。影片画面明快治愈，献给每一个曾经害怕长大的孩子。",
  },
  {
    id: 17,
    title: "都市猎人",
    type: "电视剧",
    genres: ["动作", "犯罪"],
    region: "香港",
    year: 2022,
    rating: 7.8,
    hot: 5940,
    updated: "2024-04-30",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20Hong%20Kong%20action%20series%20poster%20art%2C%20urban%20rooftop%20chase%20scene%2C%20deep%20blue%20city%20night%20and%20warm%20orange%20street%20glow%2C%20dynamic%20cinematic%20lighting%2C%20high%20detail%2C%20gritty%20key%20art%2C%20no%20text&width=480&height=672&seq=poster-17&orientation=portrait",
    director: "叶伟信宏",
    actors: ["甄子豪", "古天乐成", "刘亦菲娜"],
    episodes: 30,
    synopsis: "一名卧底警探潜伏于城市地下势力多年，身份却在一次行动中意外暴露。为了完成任务，他必须在黑白两道之间做出抉择。剧集动作场面凌厉，悬念层层递进，尽显港式犯罪剧的张力。",
  },
  {
    id: 18,
    title: "月光恋人",
    type: "电视剧",
    genres: ["爱情", "奇幻"],
    region: "韩国",
    year: 2023,
    rating: 8.3,
    hot: 7020,
    updated: "2024-08-28",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20fantasy%20romance%20series%20poster%20art%2C%20magical%20moonlit%20garden%20with%20two%20figures%2C%20deep%20blue%20night%20and%20warm%20orange%20lantern%20glow%2C%20dreamy%20cinematic%20lighting%2C%20high%20detail%2C%20enchanting%20key%20art%2C%20no%20text&width=480&height=672&seq=poster-18&orientation=portrait",
    director: "朴赞旭",
    actors: ["金泰熙", "李敏镐", "宋慧乔"],
    episodes: 16,
    synopsis: "一位能在满月之夜看见前世的女孩，与一位活在五百年前的剑客相遇。跨越时空的缘分，让他们一次次在月光下重逢。剧集将奇幻设定与细腻情感融合，讲述命中注定的爱与等待。",
  },
  {
    id: 19,
    title: "战火兄弟",
    type: "电影",
    genres: ["战争", "剧情"],
    region: "美国",
    year: 2021,
    rating: 8.5,
    hot: 6380,
    updated: "2024-02-14",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20war%20drama%20movie%20poster%20art%2C%20soldiers%20advancing%20across%20a%20smoky%20field%2C%20deep%20blue%20dawn%20and%20warm%20orange%20explosion%20glow%2C%20dramatic%20cinematic%20lighting%2C%20high%20detail%2C%20powerful%20key%20art%2C%20no%20text&width=480&height=672&seq=poster-19&orientation=portrait",
    director: "史蒂文·米勒",
    actors: ["布拉德·库珀", "迈克尔·霍根", "詹姆斯·李"],
    episodes: 140,
    synopsis: "二战战场上一支小分队被派往执行几乎不可能完成的救援任务。八个来自不同地方的士兵，在炮火中结下生死情谊。影片以真实战场质感，刻画战争中的人性光辉与沉重代价。",
  },
  {
    id: 20,
    title: "时间的旅人",
    type: "电影",
    genres: ["科幻", "爱情"],
    region: "英国",
    year: 2024,
    rating: 8.6,
    hot: 8560,
    updated: "2024-09-20",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20time%20travel%20romance%20movie%20poster%20art%2C%20a%20lone%20traveler%20before%20giant%20glowing%20clocks%2C%20deep%20blue%20time%20vortex%20and%20warm%20orange%20light%2C%20dramatic%20cinematic%20lighting%2C%20high%20detail%2C%20poetic%20key%20art%2C%20no%20text&width=480&height=672&seq=poster-20&orientation=portrait",
    director: "托马斯·格林",
    actors: ["本尼迪克·肖", "凯特·温斯", "瑞秋·布莱克"],
    episodes: 128,
    synopsis: "一位物理学家意外掌握了穿越时间的能力，却发现自己每一次改变过去，都会让爱人离他更远。为了守护所爱，他必须学会接受遗憾。影片以精巧的时间线结构，讲述关于选择与成全的动人故事。",
  },
  {
    id: 21,
    title: "厨房革命",
    type: "电视剧",
    genres: ["喜剧", "生活"],
    region: "中国大陆",
    year: 2023,
    rating: 7.7,
    hot: 5480,
    updated: "2024-07-12",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20food%20comedy%20series%20poster%20art%2C%20warm%20busy%20kitchen%20with%20cooking%20action%2C%20deep%20blue%20evening%20and%20warm%20orange%20kitchen%20glow%2C%20cozy%20cinematic%20lighting%2C%20high%20detail%2C%20appetizing%20key%20art%2C%20no%20text&width=480&height=672&seq=poster-21&orientation=portrait",
    director: "钱多多",
    actors: ["沙溢鹏", "闫妮娜", "雷佳音响"],
    episodes: 24,
    synopsis: "一家濒临倒闭的小餐馆，迎来了一位固执又冒失的年轻主厨。他和一群性格迥异的街坊食客，用一道道家常菜重新点燃了生活的热气。剧集轻松逗趣，又充满人间烟火的温度。",
  },
  {
    id: 22,
    title: "暗流涌动",
    type: "电视剧",
    genres: ["悬疑", "政治"],
    region: "美国",
    year: 2024,
    rating: 8.8,
    hot: 7890,
    updated: "2024-09-30",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20political%20thriller%20series%20poster%20art%2C%20shadowy%20capitol%20corridor%20with%20a%20lone%20figure%2C%20deep%20blue%20shadows%20and%20warm%20orange%20spotlight%2C%20tense%20cinematic%20lighting%2C%20high%20detail%2C%20gripping%20key%20art%2C%20no%20text&width=480&height=672&seq=poster-22&orientation=portrait",
    director: "大卫·芬奇曼",
    actors: ["凯文·史派西德", "罗宾·怀特", "马修·麦康"],
    episodes: 12,
    synopsis: "一位年轻的女记者在调查一桩旧案时，意外触及高层权力网络的裂缝。真相越接近，她面对的阻力就越危险。剧集以冷峻克制的叙事，揭开权力棋盘下涌动的暗流。",
  },
  {
    id: 23,
    title: "剑影传说",
    type: "电影",
    genres: ["奇幻", "动作"],
    region: "中国大陆",
    year: 2022,
    rating: 7.5,
    hot: 5620,
    updated: "2024-03-10",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20fantasy%20action%20movie%20poster%20art%2C%20warrior%20with%20glowing%20sword%20before%20a%20dragon%2C%20deep%20blue%20storm%20and%20warm%20orange%20fire%20glow%2C%20epic%20cinematic%20lighting%2C%20high%20detail%2C%20legendary%20key%20art%2C%20no%20text&width=480&height=672&seq=poster-23&orientation=portrait",
    director: "徐克强",
    actors: ["吴京龙", "周迅儿", "陈坤宇"],
    episodes: 134,
    synopsis: "传说中能斩断命运的神剑，被封印在沉睡千年的龙渊之下。一位被命运选中的少年，为了守护家园踏上取剑之路。影片特效恢弘，东方奇幻的想象在银幕上徐徐展开。",
  },
  {
    id: 24,
    title: "快乐一家人",
    type: "电视剧",
    genres: ["喜剧", "家庭"],
    region: "中国大陆",
    year: 2021,
    rating: 7.9,
    hot: 5260,
    updated: "2024-01-18",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20family%20comedy%20series%20poster%20art%2C%20cheerful%20family%20home%20at%20evening%2C%20deep%20blue%20dusk%20and%20warm%20orange%20window%20glow%2C%20heartwarming%20cinematic%20lighting%2C%20high%20detail%2C%20joyful%20key%20art%2C%20no%20text&width=480&height=672&seq=poster-24&orientation=portrait",
    director: "尚敬波",
    actors: ["宋丹丹妮", "葛优优", "杨紫莹"],
    episodes: 32,
    synopsis: "一个三代同堂的大家庭，每天都在上演鸡毛蒜皮又啼笑皆非的故事。吵吵闹闹之间，藏的是最真挚的亲情。剧集用温暖幽默的日常，讲述平凡人家简单而踏实的幸福。",
  },
];

export const typeOptions: string[] = ["电影", "电视剧"];

export const genreOptions: string[] = [
  "动作",
  "爱情",
  "科幻",
  "悬疑",
  "喜剧",
  "动画",
  "犯罪",
  "奇幻",
  "战争",
  "剧情",
  "恐怖",
  "冒险",
  "古装",
  "武侠",
  "都市",
  "年代",
  "历史",
  "赛车",
  "灾难",
  "罪案",
  "政治",
  "生活",
  "家庭",
];

export const regionOptions: string[] = [
  "中国大陆",
  "美国",
  "香港",
  "韩国",
  "日本",
  "英国",
];

export const yearOptions: number[] = [2024, 2023, 2022, 2021];

export interface CategoryEntry {
  key: string;
  name: string;
  icon: string;
  desc: string;
  href: string;
}

export const categoryEntries: CategoryEntry[] = [
  { key: "movie", name: "电影", icon: "ri-movie-2-line", desc: "院线大片与经典佳作", href: "/category?type=电影" },
  { key: "tv", name: "电视剧", icon: "ri-tv-2-line", desc: "热播剧集持续更新", href: "/category?type=电视剧" },
  { key: "action", name: "动作", icon: "ri-boxing-line", desc: "肾上腺素飙升", href: "/category?genre=动作" },
  { key: "romance", name: "爱情", icon: "ri-heart-3-line", desc: "心动瞬间", href: "/category?genre=爱情" },
  { key: "scifi", name: "科幻", icon: "ri-planet-line", desc: "遨游星辰大海", href: "/category?genre=科幻" },
  { key: "suspense", name: "悬疑", icon: "ri-magic-line", desc: "层层烧脑反转", href: "/category?genre=悬疑" },
  { key: "comedy", name: "喜剧", icon: "ri-emotion-happy-line", desc: "捧腹开怀解压", href: "/category?genre=喜剧" },
  { key: "animation", name: "动画", icon: "ri-rocket-2-line", desc: "治愈全家共享", href: "/category?genre=动画" },
];

export interface TopicCollection {
  id: string;
  title: string;
  subtitle: string;
  movieIds: number[];
}

export const topicCollections: TopicCollection[] = [
  {
    id: "must-watch",
    title: "本周必看",
    subtitle: "编辑精选，本周口碑最热的高分影视",
    movieIds: [1, 15, 22, 20, 8, 10],
  },
  {
    id: "hd-epic",
    title: "高清巨制",
    subtitle: "视听震撼，大屏观看更过瘾的视效大片",
    movieIds: [5, 13, 19, 10, 23, 11],
  },
  {
    id: "binge-drama",
    title: "一口气追完",
    subtitle: "剧情紧凑停不下来，周末熬夜首选剧集",
    movieIds: [2, 4, 18, 17, 21, 24],
  },
  {
    id: "family-time",
    title: "合家欢时光",
    subtitle: "老少皆宜，适合陪伴家人一起观看",
    movieIds: [16, 24, 21, 7, 9, 12],
  },
];